import type { GraphQLError } from "graphql";
import { z } from "zod";

export const AuthTokenSchema = z.object({
  /** Access token, which may be JWT or opaque depending on the auth flow. */
  accessToken: z.string(),
  /** Refresh token, when available. */
  refreshToken: z.string().optional(),
});

export type AuthToken = z.infer<typeof AuthTokenSchema>;

export const AuthDataSchema = z.object({
  token: AuthTokenSchema,
  shouldRemember: z.boolean(),
});

export type AuthData = z.infer<typeof AuthDataSchema>;

export interface GraphQLAuthError extends GraphQLError {
  extensions: {
    code: string;
    authError?: {
      statusCode: number;
    };
    response?: {
      statusCode: number;
      message?: string[];
    };
  };
}
